var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { modalId: "modal-lv3", size: "lg3", withBgClickEvent: true },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "flex flex-row justify-between items-center" },
              [
                _c("div", [
                  _c(
                    "p",
                    {
                      staticClass: "text-primary-black font-semibold text-base",
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.title) + " "),
                      _c("span", { staticClass: "count" }, [
                        _vm._v("(" + _vm._s(_vm.totalCount) + ")"),
                      ]),
                    ]
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass:
                      "ml-2 mr-2 text-gray-400 hover:text-gray-500 focus:text-gray-500 focus:outline-none",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                      mouseover: function ($event) {
                        _vm.isHovered = true
                      },
                      mouseout: function ($event) {
                        _vm.isHovered = false
                      },
                    },
                  },
                  [
                    !_vm.isHovered
                      ? _c("CrossIcon", { staticClass: "h-4 w-4" })
                      : _vm._e(),
                    _vm.isHovered
                      ? _c("CrossIconHover", { staticClass: "h-4 w-4" })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "div",
              {},
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "mb-8 flex warningText flex-row justify-between w-full",
                  },
                  [
                    _c("div", { staticClass: "flex flex-row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "mt-1 h-4 w-auto",
                          attrs: { alt: "delete notes" },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c(
                                "g",
                                { attrs: { id: "Icon / InfoCircleFilled" } },
                                [
                                  _c("path", {
                                    attrs: {
                                      id: "Vector",
                                      d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8.5 11.375C8.5 11.4438 8.44375 11.5 8.375 11.5H7.625C7.55625 11.5 7.5 11.4438 7.5 11.375V7.125C7.5 7.05625 7.55625 7 7.625 7H8.375C8.44375 7 8.5 7.05625 8.5 7.125V11.375ZM8 6C7.80374 5.99599 7.61687 5.91522 7.47948 5.775C7.3421 5.63478 7.26515 5.4463 7.26515 5.25C7.26515 5.0537 7.3421 4.86522 7.47948 4.725C7.61687 4.58478 7.80374 4.50401 8 4.5C8.19626 4.50401 8.38313 4.58478 8.52052 4.725C8.6579 4.86522 8.73485 5.0537 8.73485 5.25C8.73485 5.4463 8.6579 5.63478 8.52052 5.775C8.38313 5.91522 8.19626 5.99599 8 6Z",
                                      fill: "#070823",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c("p", { staticClass: "child ml-2" }, [
                        _vm._v(
                          " The suggested resources are based on the tags in the resource profile. If these suggestions don’t fit your requirements, visit your Talent Directory and select an assignee there. "
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c("SuggestedResourceTable", {
                  attrs: {
                    suitableContractors: _vm.suitableContractors,
                    visitId: _vm.visitId,
                  },
                  on: {
                    activityUpdated: _vm.activityUpdated,
                    close: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                }),
                _c(
                  "div",
                  { staticClass: "flex justify-end mt-5" },
                  [
                    _c("UiButton", {
                      staticClass: "ml-auto",
                      attrs: {
                        buttonText: "Back",
                        variant: "black",
                        size: "lg2",
                        buttonClasses: "customHeight40",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }